module.exports = __webpack_public_path__ + "static/media/card-image-2.75c460b9.jpg";